import { render, staticRenderFns } from "./form-forgot-password.vue?vue&type=template&id=890ea0a4&scoped=true&"
import script from "./form-forgot-password.vue?vue&type=script&lang=js&"
export * from "./form-forgot-password.vue?vue&type=script&lang=js&"
import style0 from "./form-forgot-password.vue?vue&type=style&index=0&id=890ea0a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890ea0a4",
  null
  
)

export default component.exports